<template>
  <v-data-table
    :headers="tableHeaders"
    :items="filteredProducts"
    multi-sort
    item-key="name"
    :expanded.sync="expanded"
    :single-expand="singleExpand"
    :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
    :options.sync="options"
    no-data-text="Nenhum produto adicionado ainda"
  >
    <!-- table content -->
    <template v-slot:item="{ item, expand, isExpanded, index }">
      <tr>
        <td>
          <div v-if="isMultipleEans(item)">
            <mf-button color="marca-1" type="icon" :icon="isExpanded ? 'indeterminate_check_box' : 'add_box'" size="sm" @click="expand(!isExpanded)" />
          </div>
        </td>

        <td>
          {{ item.sku }}
        </td>

        <td>
          <div class="py-0">
            <span v-if="item.product && item.product.eans && item.product.eans.length > 1">
              {{ getEansCount(item) }}
            </span>
            <span v-else style="word-break: keep-all">
              {{ item.ean }}
            </span>
          </div>
        </td>

        <td>
          <span>{{ item.name }}</span>
        </td>

        <td v-if="!isRevision">
          <mf-button icon="delete" type="icon" color="cinza-l30" :disabled="disabled" @click="$emit('remove-item', item)" />
        </td>
      </tr>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td class="expanded-itens" :colspan="headers.length">
        <v-checkbox
          v-for="ean in toSet(item.product.eans)"
          :key="ean"
          v-model="item.eans"
          :value="ean"
          :label="ean"
          :disabled="isCheckboxDisabled(ean, item.eans) || disabled"
          color="marca-1"
          multiple
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { offerSalesTables } from '@/modules/campanhas/gestao-ofertas-v2/views/mixins/offer-sales-tables.js'
export default {
  name: 'ProductsTable',
  mixins: [offerSalesTables],
  data: () => ({
    expanded: [],
    singleExpand: true,
  }),
  computed: {
    tableHeaders() {
      return [
        {
          text: '',
          value: 'expandAction',
          width: '60px',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '20%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '56%',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}

.expanded-itens {
  padding-left: 19%;
}

::v-deep th,
::v-deep td {
  padding: 0 8px;
}
</style>
